<article class="container" gdGap="1.7rem">
  <header>
    <agl-heading first="" second="Upcoming Courses"></agl-heading>
  </header>

  <div gdColumns="repeat(auto-fit, minmax(20rem, 1fr))" gdGap="2rem">
    <ng-content></ng-content>
  </div>
</article>
